export enum Sex {
  male = 0,
  female = 1,
}
